"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const theme_1 = require("../../theme");
const auth0_react_1 = require("@auth0/auth0-react");
const common_styled_components_1 = require("../common-styled-components");
const HeaderImage_1 = __importDefault(require("../custom/HeaderImage"));
const AhtiLogo_1 = __importDefault(require("../custom/AhtiLogo"));
const styled_components_1 = __importDefault(require("styled-components"));
const LoginPageBackground = styled_components_1.default.div `
  background-color: white;
  width: 100%;
  height: 100%;
  border-radius: ${common_styled_components_1.DEFAULT_RADIUS};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
`;
exports.default = () => {
    const { loginWithRedirect } = (0, auth0_react_1.useAuth0)();
    return ((0, jsx_runtime_1.jsx)(common_styled_components_1.ContainerCard, { maxWidth: 640, children: (0, jsx_runtime_1.jsxs)(LoginPageBackground, { children: [(0, jsx_runtime_1.jsx)(HeaderImage_1.default, { roundTop: true, minHeight: 200 }), (0, jsx_runtime_1.jsx)(AhtiLogo_1.default, { style: {
                        marginTop: theme_1.theme.spacing(5),
                        marginBottom: theme_1.theme.spacing(4),
                    } }), (0, jsx_runtime_1.jsx)(common_styled_components_1.Button, { style: {
                        minWidth: 120,
                        minHeight: 40,
                        marginBottom: theme_1.theme.spacing(6),
                    }, onClick: (e) => {
                        e.preventDefault();
                        loginWithRedirect();
                    }, children: "Log in" })] }) }));
};
